module.exports = __webpack_public_path__ + "static/mr-concert-performance-19-2b6ab71097823d8c61d628df3b77b662.jpg";